import { TypeBreadcrumbReplacementWithoutUnresolvableLinksResponse } from 'bb-contentful-types'
import { capitalize } from 'src/blogBuilder/utils/manipulateString'
import STATIC_CONTENTS from './staticContent'
import { hash } from '../../siteBuilder/utils/hash'
import { BlogUrl } from './blogUrl'
import { GenericBlogTemplate } from './types/theme'

type Slugs = { id: string; label: string; slug: string }[]

type BreadCrumbData = {
  breadcrumbReplacements?: TypeBreadcrumbReplacementWithoutUnresolvableLinksResponse[]
  pageUrl?: string
  homeLink?: boolean | null
}

type GetSlugsFromUrl = (breadcrumbs: BreadCrumbData, lang: string) => Slugs

export const getBreadcrumbData: GetSlugsFromUrl = (breadcrumbData = {}, lang) => {
  const { breadcrumbReplacements, pageUrl, homeLink } = breadcrumbData || {}
  if (!pageUrl || !breadcrumbReplacements) return []

  const urls = pageUrl.replace(/^\/|\/$/g, '').split('/')
  const slug = urls[urls.length - 1]

  const filteredBreadcrumbs = breadcrumbReplacements
    .map((d, i) => {
      if (slug === d.fields.key || 'blog' === d.fields.key)
        return {
          key: d.fields.key,
          id: hash(`${i}/${d.fields.value}`),
          label: capitalize(d.fields.value),
          slug: d.fields.key === 'blog' ? `/${lang}/blog` : `/${lang}/${d.fields.key}`,
        }
    })
    .filter((d) => d)

  const breadcrumbs = [
    filteredBreadcrumbs.find((d) => d.key === 'blog'),
    filteredBreadcrumbs.find((d) => d.key === slug),
  ]
  const slugCrumb = breadcrumbs.splice(0, 1)[0]
  breadcrumbs.push(slugCrumb)
  homeLink &&
    breadcrumbs.unshift({
      key: 'home',
      id: hash(`/${lang}/`),
      label: STATIC_CONTENTS.BREADCRUMBS.HOME_LINK[lang],
      slug: `/${lang}/`,
    })
  return breadcrumbs.filter((breadcrumb) => breadcrumb)
}

type Blog = {
  breadcrumbs: {
    fields: {
      breadcrumbReplacements: TypeBreadcrumbReplacementWithoutUnresolvableLinksResponse[]
    }
  }
}

type BlogBreadcrumbs = {
  baseUrl: string
  breadcrumbReplacements: TypeBreadcrumbReplacementWithoutUnresolvableLinksResponse[]
  pageUrl: string
}

type AreBlogBreadcrumbsValid = (blog: GenericBlogTemplate) => {
  fields: { breadcrumbReplacements: TypeBreadcrumbReplacementWithoutUnresolvableLinksResponse[] }
}
type AreUrlsValid = (urls: BlogUrl) => string

const areBlogBreadcrumbsValid: AreBlogBreadcrumbsValid = (blog) => blog && blog.breadcrumbs
const areUrlsValid: AreUrlsValid = (urls) => urls && urls.hostName && urls.currentLang

type BuildBlogBreadcrumbs = (blog: GenericBlogTemplate, fullBlogUrls: BlogUrl) => BlogBreadcrumbs

export const buildBlogBreadcrumbs: BuildBlogBreadcrumbs = (blog, fullBlogUrls) => {
  if (!areBlogBreadcrumbsValid(blog) || !areUrlsValid(fullBlogUrls)) return null
  const blogBreadcrumbs = {
    ...blog.breadcrumbs,
    baseUrl: fullBlogUrls.hostName,
    pageUrl: fullBlogUrls.currentLang,
    breadcrumbReplacements: blog.breadcrumbs.fields.breadcrumbReplacements,
    homeLink: blog.breadcrumbs.fields.homeLink,
  }
  delete blogBreadcrumbs.fields
  return blogBreadcrumbs
}
